module.exports = __webpack_public_path__ + "img/bowl.324a617.svg";